import Axios from '../../utils/axios';
import { getBackendErrorMessage } from '../../utils/errorHandler';

export interface Provider {
  id: number;
  ID?: number;
  name: string;
  email?: string;
  phone?: string;
  address?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface ProviderListResponse {
  data: Provider[];
  pagination: {
    total: number;
    page: number;
    size: number;
    lastPage: number;
  };
}

export const getListProvider = async (params: {
  page?: string;
  size?: string;
  search?: string;
}): Promise<ProviderListResponse> => {
  try {
    const response = await Axios.get('/v1/providers', { params });
    return response.data;
  } catch (error) {
    throw new Error(getBackendErrorMessage(error));
  }
};
